import React, { useState } from 'react'
import Tooltip from 'rc-tooltip'
import { Button } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { CertificateInfo, CertificateStatusEnum } from './models/certificate-info'

function CertificateInfoTableRow({
  index,
  certificateInfo,
}: Readonly<{ index: number; certificateInfo: CertificateInfo }>) {
  const { t } = useTranslation()

  const [isRowClosed, setIsRowClosed] = useState(true)

  const {
    subject, issuer, name, validTo, validFrom, fingerprint,
  } = certificateInfo

  function getStatusIcon(row: CertificateInfo) {
    switch (row.status) {
      case CertificateStatusEnum.VALID:
        return (
          <Tooltip overlayClassName="tooltip-lg" overlay={<small>{`${row.validFrom} - ${row.validTo} (${row.status})`}</small>}>
            <i className="fal fa-check-circle text-success" />
          </Tooltip>
        )
      case CertificateStatusEnum.EXPIRED:
        return (
          <Tooltip overlayClassName="tooltip-lg" overlay={<small>{`${row.validFrom} - ${row.validTo} (${row.status})`}</small>}>
            <i className="fal fa-times-circle text-danger" />
          </Tooltip>
        )
      default:
        return (
          <Tooltip overlayClassName="tooltip-lg" overlay={<small>{`${row.validFrom} - ${row.validTo} (${row.status})`}</small>}>
            <i className="fal fa-exclamation-triangle text-warning" />
          </Tooltip>
        )
    }
  }

  return (
    <>
      <tr className="m-0 p-0">
        <td>{getStatusIcon(certificateInfo)}</td>
        <td>{validTo}</td>
        <td>{name}</td>
        <td className="text-end">
          <Button
            type="button"
            className="btn-sm me-2"
            title="blaa"
            variant="primary font-size-sm"
            data-bs-toggle="collapse"
            data-bs-target={`#row_${index}`}
            aria-expanded={isRowClosed}
            aria-controls={`row_${index}`}
            tabIndex={0}
            onClick={() => setIsRowClosed(!isRowClosed)}
            onKeyDown={() => setIsRowClosed(!isRowClosed)}
          >
            {t('certificates.showDetails')}
          </Button>
        </td>
      </tr>
      <tr
        className={`collapse ${isRowClosed ? '' : 'show'}`}
        id={`row_${index}`}
      >
        <td colSpan={4}>
          { !isRowClosed && (
            <table className="w-100">
              <tbody>
                <tr>
                  <td>{t('certificates.validFrom')}</td>
                  <td>{validFrom}</td>
                </tr>
                <tr>
                  <td>{t('certificates.validTo')}</td>
                  <td>{validTo}</td>
                </tr>
                <tr>
                  <td>{t('certificates.subject')}</td>
                  <td>{subject}</td>
                </tr>
                <tr>
                  <td>{t('certificates.issuer')}</td>
                  <td>
                    <span className="text-wrap text-break">
                      {issuer}
                    </span>
                  </td>
                </tr>
                <tr>
                  <td>{t('certificates.fingerprint')}</td>
                  <td>{fingerprint}</td>
                </tr>
              </tbody>
            </table>
          )}
        </td>
      </tr>
    </>
  )
}

export default CertificateInfoTableRow
